import type { SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@/integrations/supabase/types";

export async function fetchWorkspaceUnreadInboxTotal(
  supabase: SupabaseClient<Database>,
  workspaceId: string,
): Promise<number> {
  const { data, error } = await (supabase.rpc as unknown as (fn: string, args: Record<string, unknown>) => Promise<{ data: unknown; error: unknown }>)("get_workspace_unread_inbox_total", {
    p_workspace_id: workspaceId,
  });

  if (error) throw error;
  return Number(data ?? 0);
}
